export const PM_SESSION_START = 'PM_SESSION_START';
export const PM_SESSION_HIDE = 'PM_SESSION_HIDE';

export const PM_SESSION_ACCEPTED = 'PM_SESSION_ACCEPTED';
export const PM_SESSION_DECLINED = 'PM_SESSION_DECLINED';
export const PM_SESSION_REVOKED = 'PM_SESSION_REVOKED';


export const PM_ACCESS_REQUEST = 'PM_ACCESS_REQUEST';
export const PM_ACCESS_CHANGE_ALLOWED = 'PM_ACCESS_CHANGE_ALLOWED';
export const PM_ACCESS_CHANGE_DENIED = 'PM_ACCESS_CHANGE_DENIED';
export const PM_ACCESS_CHANGE_UNDEFINED = 'PM_ACCESS_CHANGE_UNDEFINED';
export const PM_REQUEST_CANCELLED = 'PM_REQUEST_CANCELLED';

export const PM_ACCESS_RESET_REASON_REQUEST_CANCEL = 'cancel';

export const PM_MESSAGE = 'PM_MESSAGE';
export const PM_HISTORY = 'PM_HISTORY';
export const PM_TYPING_NOTIFY = 'PM_TYPING_NOTIFY';
export const PM_CLEAR_TYPING_NOTIFY = 'PM_CLEAR_TYPING_NOTIFY';

export const PM_DELETE_HISTORY = 'PM_DELETE_HISTORY';

export const PM_ACCESS_ALLOW = 'allow';
export const PM_ACCESS_DENY = 'deny';
export const PM_ACCESS_DENIED_BY_ME = 'denied_by_me';
export const PM_ACCESS_UNDEFINED = 'undefined';
export const PM_ACCESS_NEGOTIATING = 'negotiating';
export const PM_ACCESS_DENIED_BY = 'denied_by';
export const PM_ACCESS_REQUESTED_BY = 'requested_by';

export const PM_WINDOW_MINIMIZE = 'PM_WINDOW_MINIMIZE';
export const PM_WINDOW_MAXIMIZE = 'PM_WINDOW_MAXIMIZE';
export const PM_WINDOW_MINIMIZE_ALL = 'PM_WINDOW_MINIMIZE_ALL';

export const PM_CONVERSATION_LIST = 'PM_CONVERSATION_LIST';
export const PM_CONVERSATIONS = 'PM_CONVERSATIONS';
export const PM_CONVERSATION_CHANGED = 'PM_CONVERSATION_CHANGED';
export const PM_CLIENT_LOGIN = 'PM_CLIENT_LOGIN';
export const PM_CLIENT_LOGOUT = 'PM_CLIENT_LOGOUT';
export const PM_CLIENT_UPDATE = 'PM_CLIENT_UPDATE';
export const PM_USER_UPDATE = 'PM_USER_UPDATE';
export const PM_CLOSE = 'PM_CLOSE';
export const PM_PRECONNECT = 'PM_PRECONNECT';
export const PM_DISCONNECT = 'PM_DISCONNECT';
export const PM_PRELOGIN = 'PM_PRELOGIN';


export const STATE_UNDEFINED = 'undefined';
export const STATE_REQUESTED_BY_RECIPIENT = 'requested_by_recipient';
export const STATE_REQUESTED_BY_ME = 'requested_by_me';
export const STATE_DENIED_BY_RECIPIENT = 'denied_by_recipient';
export const STATE_DENIED_BY_ME = 'denied_by_me';
export const STATE_ALLOWED = 'allowed';



// WEBPACK FOOTER //
// ./src/constants/pm.js